interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  variant?: "light" | "dark";
}

const SectionHeading = ({ 
  title, 
  subtitle, 
  align = "center", 
  variant = "light" 
}: SectionHeadingProps) => {
  return (
    <div className={`mb-10 md:mb-12 ${align === "center" ? "text-center" : "text-left"}`}>
      <h2 className={`text-3xl md:text-4xl lg:text-5xl font-playfair font-semibold mb-4 ${
        variant === "light" ? "text-secondary" : "text-cream"
      }`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`text-lg md:text-xl max-w-2xl ${
          align === "center" ? "mx-auto" : ""
        } ${
          variant === "light" ? "text-secondary/70" : "text-cream/80"
        }`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
